import getRestUrl from "@gef-ui/utils/getRestUrl";
export const concatOpenidScope = (input = '')=>(input.includes('openid') ? input : `openid ${input}`).trim();
export const parseQuery = (queryString)=>{
    const strippedQueryString = queryString.trim().replace(/^[?#&]/, '');
    if (!strippedQueryString) {
        return {};
    }
    const queryParams = strippedQueryString.split('&');
    const parsedQuery = {};
    queryParams.forEach((qp)=>{
        const [key, val] = qp.split('=');
        parsedQuery[key] = decodeURIComponent(val);
    });
    return parsedQuery;
};
export const createQueryParams = (params)=>{
    return Object.keys(params).filter((k)=>typeof params[k] !== 'undefined').map((k)=>`${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`).join('&');
};
export const getLocationPersistenceStateString = (locationSearchState, { pathname, hash, search })=>{
    return JSON.stringify({
        pathname,
        hash,
        search: createQueryParams({
            state: locationSearchState,
            ...parseQuery(search)
        }),
        originatedFromApp: true
    });
};
export const parseState = (state)=>{
    try {
        return JSON.parse(state);
    } catch (_e) {
        return undefined;
    }
};
export const getAuthorizeUrl = (apiGtwUrl)=>`${apiGtwUrl}/auth/oauth/v2/authorize`;
export const getTokenRevokeUrl = (apiGtwUrl)=>`${apiGtwUrl}/auth/oauth/v2/token/revoke`;
export const getTokenUrl = (apiGtwUrl)=>`${apiGtwUrl}/auth/oauth/v2/token`;
export const getLogoutUrl = ({ apiGtwUrl, redirectUri, clientId })=>`${apiGtwUrl}/utils/oauth2/logout?${createQueryParams({
        client_id: clientId,
        redirect_uri: redirectUri
    })}`;
export const sha256 = (string)=>window.crypto.subtle.digest({
        name: 'SHA-256'
    }, new TextEncoder().encode(string));
export const urlEncodeB64 = (input)=>{
    const b64Chars = {
        '+': '-',
        '/': '_',
        '=': ''
    };
    return input.replace(/[+/=]/g, (m)=>b64Chars[m]);
};
export const bufferToBase64UrlEncoded = (input)=>{
    const ie11SafeInput = new Uint8Array(input);
    return urlEncodeB64(window.btoa(String.fromCharCode(...Array.from(ie11SafeInput))));
};
export const createRandomString = ()=>{
    const charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.';
    let random = '';
    const randomValues = Array.from(window.crypto.getRandomValues(new Uint8Array(43)));
    randomValues.forEach((v)=>{
        random += charset[v % charset.length];
    });
    return random;
};
export const createEncodedPost = (body)=>{
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: new URLSearchParams(body)
    };
};
export const revokeToken = async ({ apiGtwUrl, token, tokenType, clientId })=>await fetch(getTokenRevokeUrl(apiGtwUrl), createEncodedPost({
        client_id: clientId,
        token,
        token_type_hint: tokenType
    }));
export const sendMessageToWorker = (message, to)=>new Promise(function(resolve, reject) {
        const messageChannel = new MessageChannel();
        messageChannel.port1.onmessage = function(event) {
            if (event.data.error) {
                reject(new Error(event.data.error));
            } else {
                resolve(event.data);
            }
        };
        to.postMessage(message, [
            messageChannel.port2
        ]);
    });
export const retryPromise = async (cb, maxNumberOfRetries = 3)=>{
    for(let i = 0; i < maxNumberOfRetries; i++){
        if (await cb()) {
            return true;
        }
    }
    return false;
};
export const createCodeVerifierKey = (clientId)=>`gef.code_verifier.${clientId}`;
export const createPromptAuthorizationUri = ({ redirectUri, clientId, apiGtwUrl, scope }, persistLocationState, redirectStateSearchParam)=>async (prompt, locationPersistentState, params = {})=>{
        return getRestUrl(getAuthorizeUrl(apiGtwUrl), {
            urlParams: {
                response_type: 'code',
                redirect_uri: redirectUri,
                client_id: clientId,
                scope: concatOpenidScope(scope),
                state: persistLocationState ? locationPersistentState : redirectStateSearchParam,
                prompt,
                ...params
            }
        });
    };
